import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  constructor(
    private router: Router,
  ) {
  }

  ngOnInit() {
    timer(8000).subscribe(() => {
      this.router.navigate(['login']);
    });
  }

  signIn() {
    this.router.navigate(['login']);
  }
}
